<template>
  <b-navbar toggleable="lg p-0" id="navbar-header" v-if="isActive" ref="toggle">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-brand
      href="#"
      class="ml-5 text-primary font-weight-normal brand-font"
    >
      <b-img
        :src="require('@/assets/etouch-png.png')"
        class="header-brand-img"
      ></b-img>
    </b-navbar-brand>
    <b-navbar-nav class="" id="nav-settings-responsive">
      <b-nav-item-dropdown right class="dropdown dropdown-custom">
        <template #button-content class="btn-header">
          <svg class="b-icon-custom icon-sphere mr-1">
            <use
              xlink:href="@/../public/icons/symbol-defs.svg#icon-sphere"
            ></use>
          </svg>
        </template>
        <div class="d-flex flex-row navbar-administration">
          <div class="d-flex flex-column flex-grow-1 flex-nowrap right-panel">
            <b-dropdown-item
              v-for="language in languages"
              :key="language.code"
              href="#"
              class="text-uppercase"
              @click="changeLanguage(language)"
            >
              {{ language.code }}
            </b-dropdown-item>
          </div>
        </div>
      </b-nav-item-dropdown>

      <b-nav-item-dropdown right class="dropdown dropdown-custom">
        <template #button-content class="btn-header">
          <b-icon-person-circle
            variant="outline-primary"
            class="mr-1 b-icon-custom"
          />
        </template>
        <div class="d-flex flex-row navbar-administration">
          <div class="d-flex flex-column flex-grow-1 flex-nowrap right-panel">
            <b-dropdown-item href="#">{{
              $store.getters.userRole
            }}</b-dropdown-item>
            <b-dropdown-item href="#" @click="logout">{{
              $t("menu.logOut")
            }}</b-dropdown-item>
          </div>
        </div>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav id="nav-menu">
        <!-- <b-nav-item
          :class="$router.currentRoute.name == 'Accueil' ? 'active' : ''"
          ><router-link to="/">{{ $t("menu.home") }}</router-link></b-nav-item
        > -->
        <b-nav-item
          :class="
            $router.currentRoute.name == 'Bop' ||
            $router.currentRoute.name == 'BopSetupAdd' ||
            $router.currentRoute.name == 'BopSetupUpdate'
              ? 'active'
              : ''
          "
          ><router-link to="/">{{
            $t("menu.bopModels")
          }}</router-link></b-nav-item
        >
        <b-nav-item
          :class="$router.currentRoute.name == 'Documentation' ? 'active' : ''"
          ><router-link to="/Documentation">{{
            $t("menu.documentation")
          }}</router-link></b-nav-item
        >
        <b-nav-item-dropdown
          :class="
            $router.currentRoute.name != 'Bop' &&
            $router.currentRoute.name != 'BopSetupAdd' &&
            $router.currentRoute.name != 'BopSetupUpdate' &&
            $router.currentRoute.name != 'Documentation'
              ? 'active'
              : ''
          "
          id="main-menu"
          left
          class="dropdown dropdown-custom"
          ref="mainDropDownMenu"
          v-if="isAdmin"
        >
          <template #button-content>
            {{ $t("menu.administration") }}
          </template>
          <div class="d-flex flex-row navbar-administration">
            <div class="d-flex flex-column flex-grow-1 flex-nowrap">
              <router-link to="/ArkemaUsers">{{
                $t("menu.arkemaUser")
              }}</router-link>
              <router-link to="/ExternalUsers">{{
                $t("menu.externalUser")
              }}</router-link>
              <router-link to="/Entreprises">{{
                $t("menu.entreprises")
              }}</router-link>
              <router-link to="/Facturation">{{
                $t("menu.facturation")
              }}</router-link>
               <router-link to="/Exports">{{
                $t("menu.exports")
              }}</router-link>
            </div>
            <div class="d-flex flex-column flex-grow-1 flex-nowrap right-panel">
              <router-link to="/bopmodels/configuration">{{
                $t("menu.bopModelSetup")
              }}</router-link>
              <router-link to="/bopmodelsSitesConfiguration">{{
                $t("menu.bopModelAccess")
              }}</router-link>
              <router-link to="/Sites">{{ $t("menu.sites") }}</router-link>
              <router-link to="/Translations">{{
                $t("menu.translations")
              }}</router-link>                
            </div>
          </div>
        </b-nav-item-dropdown>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav id="nav-settings">
        <b-nav-item-dropdown left class="dropdown dropdown-custom" id="lang">
          <template #button-content>
            <!-- <b-icon icon="flag-fill" class=""></b-icon> -->
            <svg class="b-icon-custom icon-sphere mr-1">
              <use
                xlink:href="@/../public/icons/symbol-defs.svg#icon-sphere"
              ></use>
            </svg>
            {{ $i18n.locale.toUpperCase() }}
          </template>
          <div class="d-flex flex-row navbar-administration">
            <div class="d-flex flex-column flex-grow-1 flex-nowrap right-panel">
              <b-dropdown-item
                v-for="language in languages"
                :key="language.code"
                href="#"
                class="text-uppercase"
                @click="changeLanguage(language)"
              >
                {{ language.code }}
              </b-dropdown-item>
            </div>
          </div>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right class="dropdown dropdown-custom" id="role">
          <!-- Using 'button-content' slot -->
          <template #button-content class="btn-header">
            <b-icon-person-circle
              scale="0.85"
              variant="outline-primary"
              class="mr-1"
            />
            {{ $store.getters.userShort }}
          </template>
          <div class="d-flex flex-row navbar-administration">
            <div class="d-flex flex-column flex-grow-1 flex-nowrap right-panel">
              <b-dropdown-item href="#">{{
                $store.getters.userRole
              }}</b-dropdown-item>
              <b-dropdown-item href="#" @click="logout">{{
                $t("menu.logOut")
              }}</b-dropdown-item>
            </div>
          </div>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script lang="ts">
import { loadLanguageAsync } from "@/i18n";
import LanguageService from "@/services/LanguageService";
import UserService from "@/services/UserService";
import { UserRoleEnum } from "@/utils/Enums";
import { Component,Vue,Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class AppHeader extends Vue {
  private languages: Array<any> = [];
  private userShort: string = "";

  get isActive(): Boolean {
    return !(this.$route.name == "Auth" || this.$route.name == "ResetPassword");
  }

  get isAdmin(): Boolean {
    return this.$store.getters.isAllowed([
      UserRoleEnum.countryAdministrator,
      UserRoleEnum.centralAdministrator,
      UserRoleEnum.siteAdministrator,
    ]);
  }

  public created() {
    LanguageService.getLanguages().then((res) => {
      this.languages = res.data;
    });
  }

  public mounted() {}

  private async logout() {
    // store.commit("logout");
    await UserService.logout().then(() => {
      
      this.$router.push({
      path: "/Auth",
    });
    });
    
  }

  private changeLanguage(language: any) {
    // this.$i18n.locale = language.code;
    loadLanguageAsync(language.code);
  }

  @Watch("isActive")
  onIsActiveChange() {
    if (this.isActive) {
    }
  }
  @Watch("$route")
  onRouteChange() {
    if (<any>this.$refs.mainDropDownMenu !== undefined)
      (<any>this.$refs.mainDropDownMenu).hide();
  }
}
</script>
<style scoped>
.brand-font {
  font-family: "Arkema Regular";
}
.header-brand-img {
  max-width: 90px;
}
</style>
